<template>
    <div :class="{'dxreControlOuterWrap': true, 'dxreControlFullscreen': isFullscreen, 'dxreControlReadOnly': readOnly}">
        <div ref="richEditContainer" class="rich-editor-inner-container"></div>
        
        <div :class="{'richedit-action-panel': true, 'rap-full-screen': isFullscreen }">
            <div
                v-if="!readOnly"
                class="richedit-action-btn" 
                :title="$t('На_весь_экран')"
                @click="$emit('toggle-fullscreen')"
            >
                <i class="dx-icon dxre-icon-FullScreen"></i>
            </div>   
        </div>
    </div>
</template>

<script>
import { create, createOptions, RichEditUnit, ViewType, DocumentFormat } from 'devexpress-richedit';
import { locale, loadMessages } from "devextreme/localization";
import ruMessages from '@/locales/richedit/dx-rich.ru.json';

export default {
    name: "RichTextEditor",
    props: {
        content: { type: String, default: '' }, // Base64
        fileName: { type: String, default: '' },
        extension: { type: String, default: '' },
        readOnly: { type: Boolean, default: true },
        isFullscreen: { type: Boolean, default: false },
        editorHeight: { type: String, default: '500px' }
    },
    data() {
        return {
            richInstance: null
        }
    },
    computed: {
        docFormat(){
            let ext = this.extension;
            if (!ext)
                ext = this.fileName.match(/\.([^.]+)$|$/)[0]?.toUpperCase();
            switch(ext){
                /*case '.RTF':
                    return DocumentFormat.Rtf;*/
                case '.TXT':
                    return DocumentFormat.PlainText;
                default:
                    return DocumentFormat.OpenXml;
            }
        }
    },
    watch: {
        content(newVal) {
            if (this.richInstance && newVal) {
                this.richInstance.openDocument(newVal, this.fileName, this.docFormat);
            }
        },
        readOnly: {
            immediate: true, // Запустит обработчик сразу при создании компонента
            handler(val) {
                if (this.richInstance) {
                    this.richInstance.readOnly = val;
                    /*if (this.richInstance.ribbon) {
                        this.richInstance.ribbon.visible = !val;
                    }*/
                    this.$nextTick(() => this.applyHeight());
                }
            }
        },
        editorHeight() {
            this.applyHeight();
        }
    },
    mounted() {
        this.initEditor();  
    },
    beforeDestroy() {
        if (this.richInstance) {
            this.richInstance.dispose();
            this.richInstance = null;
        }
    },
    methods: {
        initEditor() {
            loadMessages(ruMessages);
            locale("ru");

            const options = createOptions();
            options.locale = "ru";
            options.bookmarks.visibility = false;
            options.bookmarks.color = '#ff0000';
            options.readOnly = this.readOnly;
            //options.ribbon.visible = !this.readOnly;
            options.ribbon.activeTabIndex = this.readOnly ? 0 : 1;
            options.unit = RichEditUnit.Centimeter;
            options.view.viewType = ViewType.PrintLayout;
            options.view.simpleViewSettings.paddings = {
                left: 15,
                top: 15,
                right: 15,
                bottom: 15,
            };
            options.width = '100%';

            options.events.saving = (e) => {
                e.handled = true;
                this.richInstance.exportToArrayBuffer((result) => {
                    this.$emit('save', result);
                }, this.docFormat);
            };

            // Делаем кнопку сохранить активной
            options.events.documentLoaded = (s) => {
                this.$nextTick(() => {
                    const editor = s || this.richInstance;
                    if (!editor) return;

                    try {
                        // Принудительно устанавливаем флаг изменений
                        editor.hasUnsavedChanges = true;

                        // Если есть Ribbon, заставляем его обновить состояние кнопок
                        if (editor.commands && editor.commands.saveDocument) {
                            // Это заставит кнопку "Сохранить" пересчитать свой статус Enabled
                            editor.commands.saveDocument.getState();
                        }
                    } catch (err) {
                        console.warn("Could not force save button state:", err);
                    }
                });
            };

            this.richInstance = create(this.$refs.richEditContainer, options);
            
            if (this.content) {
                this.richInstance.openDocument(this.content, this.fileName, this.docFormat);
            }
            this.applyHeight();
        },
        applyHeight() {
            // Используем нативный поиск, так как DevExpress создает элементы вне контроля Vue
            const el = this.$el.querySelector('.dxreControl');
            if (el) {
                el.style.setProperty('height', this.editorHeight, 'important');
                // Если библиотека поддерживает adjust (зависит от версии)
                if (this.richInstance && this.richInstance.adjust) {
                    this.richInstance.adjust();
                }
            }
        },
        // Метод для вызова из родителя, если нужно получить актуальный base64
        exportBase64() {
            return new Promise((resolve) => {
                this.richInstance.exportToBase64((result) => resolve(result), this.docFormat);
            });
        }
    }
}
</script>